import { useState, useEffect, useCallback } from 'react'
// import { useToast } from '@mtsbank/ui-kit'

import { Payee } from '@root/api/ump-catalog-manager'
import { categoryRequestParams, reqHeaders } from '@root/components/Cyber/constansts'
import { catalogManagerApi } from '@root/api/api'
import { ESteps, Tabs } from '@root/components/Cyber/types'
import { getPcekZone } from '@root/components/Cyber/utils/utils'

const useCategoryServices = (setStep?: (step: ESteps) => void) => {
  const [categoryServices, setCategoryServices] = useState<Payee[]>([])
  const [tabsServices, setTabsServices] = useState<Record<Tabs, Payee[]>>(null)
  const [servicesAll, setServicesAll] = useState<Payee[]>([])
  const [isCategoryServicesLoading, setIsCategoryServicesLoading] = useState<boolean>(true)
  const zone = getPcekZone()

  // const { toast } = useToast()

  const fetchCategoryData = useCallback(() => {
    const { requestId, categoryName, showHidden, showFromHiddenCategories } = categoryRequestParams

    setIsCategoryServicesLoading(true)

    catalogManagerApi
      .getPayees(zone, undefined, undefined, categoryName, showHidden, showFromHiddenCategories, {
        headers: { ...reqHeaders, 'Request-Id': requestId },
      })
      .then(({ data }) => {
        const categoryServices = data.payees

        setCategoryServices(categoryServices) // Записываем данные категории в состояние
      })
      .catch((error) => {
        if (error.code !== 'ERR_CANCELED') {
          // toast('error', MESSAGE, '')
          // if (setStep) {
          //   setStep(ESteps.NOT_TCP)
          // }
        }
      })
      .finally(() => setIsCategoryServicesLoading(false))
  }, [])

  useEffect(() => {
    if (categoryServices?.length) {
      const foundService = categoryServices.find(
        (service) => service?.features && service?.features?.merchant_association_for_WEB !== undefined
      )
      const merchantAssociation = foundService?.features?.merchant_association_for_WEB as string

      const servicesForSearch = categoryServices
        .filter((serviceInfo) => {
          if (serviceInfo?.serviceId === merchantAssociation) {
            return false
          }

          if (serviceInfo?.features?.screenType || serviceInfo?.features?.merchant_association_for_WEB) return true

          if (!serviceInfo?.features?.merchant_association_for_WEB && !serviceInfo?.features?.screenType) {
            return !serviceInfo?.hidden
          }

          return false
        })
        .sort((a, b) => {
          const orderA = a.features?.displayOrder ?? Number.MAX_SAFE_INTEGER
          const orderB = b.features?.displayOrder ?? Number.MAX_SAFE_INTEGER

          return orderA - orderB
        })

      setServicesAll(servicesForSearch)

      const displayedServices = servicesForSearch.reduce((acc, service) => {
        service?.features?.category_web?.split(', ').forEach((category) => {
          if (Object.values(Tabs).includes(category as Tabs)) {
            acc[category] = acc[category] || []
            acc[category].push(service)
          }
        })

        return acc
      }, {}) as Record<Tabs, Payee[]>

      setTabsServices(displayedServices) // Записываем отображаемые сервисы (hidden !== false)
    }
  }, [categoryServices])

  return {
    categoryServices,
    tabsServices,
    servicesAll,
    isCategoryServicesLoading,
    fetchCategoryData,
  }
}

export default useCategoryServices
